import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "./initialState";

const getAdminPriceState = (state: RootState) =>
  state.AdminPriceState
    ? { ...initialState, ...state.AdminPriceState }
    : initialState;

export const selectAdminPriceData = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.priceData
)

export const selectAdminPriceLoad = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.loading
)

export const selectAdminPriceMeta = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.meta
)

export const selectAdminPricePage = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.page
)

export const selectAdminPricePerPage = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.perPage
)

export const selectAdminPriceForm = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.form
)

export const selectIsAddModalOpen = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.isAddModalOpen
)
export const selectNameDropDown = createSelector(
    [getAdminPriceState],
    (AdminPriceState)=>AdminPriceState.itemNameDropDown
)

export const selectSelectedId = createSelector(
    [getAdminPriceState],
    (AdminPriceState) => AdminPriceState.selectedId
)

